import { Link } from 'react-router-dom';
import styles from './Header.module.css';

const HeaderForLoginPage = ()=>{
   return (
     <header className={styles.header}>
        <Link to="/" className={styles.brand}>
           <span className={styles.mark}>C<span>.</span></span>
           <span><strong>CodeCognition</strong><small>ADMINISTRATION</small></span>
        </Link>
     </header>
   )

}

export default HeaderForLoginPage;
